import React, { useState } from 'react';
import { SpeedDial, SpeedDialAction, SpeedDialIcon, Box } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PeopleIcon from '@mui/icons-material/People';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { useNavigate } from 'react-router-dom';

export default function FloatingActionButton() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { 
      icon: <BusinessCenterIcon sx={{ fontSize: 20 }} />, 
      name: 'New Project',
      action: () => navigate('/projects', { state: { openDialog: true } }),
    },
    { 
      icon: <PeopleIcon sx={{ fontSize: 20 }} />, 
      name: 'New Client',
      // ✅ CORREGIDO: Navegar a /clients con state
      action: () => navigate('/clients', { state: { openDialog: true } }),
    },
    { 
      icon: <ChecklistIcon sx={{ fontSize: 20 }} />, 
      name: 'Nuevo pendiente',
      // ✅ CORREGIDO: Navegar a /tasks con state
      action: () => navigate('/tasks', { state: { openDialog: true } }),
    },
  ];

  const handleActionClick = (action) => {
    action.action();
    setOpen(false);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 88, sm: 32 },
        right: { xs: 20, sm: 32 },
        display: { xs: 'none', sm: 'flex', md: 'none' },
        zIndex: 1000,
      }}
    >
      <SpeedDial
        ariaLabel="crear nuevo"
        icon={<SpeedDialIcon />}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        direction="up"
        sx={{
          '& .MuiFab-primary': {
            width: 56,
            height: 56,
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
              backgroundColor: 'primary.dark',
            },
            transition: 'all 0.3s ease',
          },
        }}
      >
        {actions.map((action, index) => (
          <SpeedDialAction
            key={`${action.name}-${index}`}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => handleActionClick(action)}
            sx={{
              '& .MuiFab-medium': {
                width: 48,
                height: 48,
                boxShadow: 2,
                '&:hover': {
                  boxShadow: 4,
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.2s ease',
              },
            }}
          />
        ))}
      </SpeedDial>
    </Box>
  );
}
